import Color from 'color'

const color = {
  primary: '#F88D2A',
  primaryHover: Color('#F88D2A').lighten(0.2).hex(),
  secondary: '#B18978',
  secondHover: Color('#B18978').lighten(0.2).hex(),
  tertiary: '#76BC21',
  highlight: '#FFEFE0',
  accent: '#F5EA61',
}

export default color
